"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeAlphaFi = initializeAlphaFi;
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
const index_js_1 = require("./protocol/index.js");
const simpleCache_js_1 = require("./protocol/simpleCache.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const initCache = new simpleCache_js_1.SimpleCache();
async function initializeAlphaFi(options, force) {
    (0, stsui_sdk_1.setSuiNodeUrl)("https://alphalen-suimain-ef6f.mainnet.sui.rpcpool.com");
    const initCacheKey = "alphaFiInit";
    if (force) {
        initCache.delete(initCacheKey);
    }
    const cache = initCache.get(initCacheKey);
    if (cache) {
        const timePassed = (Date.now() - cache) / 1000;
        if (timePassed >= 10 && timePassed < 60) {
            await (0, alphafi_sdk_1.getMultiLatestPrices)();
        }
        return;
    }
    await (0, index_js_1.fetchStSuiApr)(7, true);
    await (0, alphafi_sdk_1.getMultiPool)();
    await (0, alphafi_sdk_1.getMultiInvestor)();
    await (0, alphafi_sdk_1.getMultiCetusPool)();
    await (0, alphafi_sdk_1.getMultiParentPool)();
    if (options.address) {
        await (0, index_js_1.getMultiTokenBalance)({
            address: options.address,
        });
        await (0, alphafi_sdk_1.getMultiReceipts)(options.address);
    }
    await (0, alphafi_sdk_1.getMultiLatestPrices)();
    initCache.set(initCacheKey, Date.now());
}
//# sourceMappingURL=initializeAlphaFi.js.map